import styled from 'styled-components';
import { Form } from 'react-bootstrap';

import ActivityAvailableDays from '../../ActivityMetaFields/ActivityAvailableDays/ActivityAvailableDays';

const AvailableDays = styled(ActivityAvailableDays)`
  label {
    margin-bottom: 10px;
  }
`;

const ErrorMessage = styled.span`
  color: #de3f44;
  display: block;
  margin-top: -10px;
`;

const Wrapper = styled(Form)`
  margin-top: 25px;
`;

const Buttons = styled.div`
  display: flex;
  align-items: center;
  button {
    width: 70px;
    margin-right: 0;
  }

  .cancel-btn {
    margin-right: 25px;
  }

  .delete-btn {
    margin-right: auto;
  }
`;

const GroupedLabel = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;

  label {
    align-content: end;
  }
`;

const S = {
  AvailableDays,
  ErrorMessage,
  Wrapper,
  Buttons,
  GroupedLabel,
};

export default S;
